import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { ConnectedDocumentService } from './connected-document-base.service';
import { PropertyDocument } from '../../model/property-document';

@Injectable()
export class PropertyDocumentService extends ConnectedDocumentService<PropertyDocument> {
  constructor(client: HttpClient, messageService: MessageService, progressBar: ProgressBarService, @Inject(APP_CONFIG) config: IAppConfig) {
    super(client, messageService, progressBar, 'property-documents', config);
  }

  createModel(): PropertyDocument {
    return new PropertyDocument();
  }
}
